import { useState } from 'react';
import { useMutation } from '@apollo/client';

import useToast from '../../../../customHooks/useToast';
import { APPROVE_LOAN } from '../../../../graphql/admin_mutations';
import AdminModal from '../../../../components/AdminModal';
import { IApproveLoanModal } from './FufilLoanModal.types';

import InfoIconNew from '../../../../svgs/InfoIconNew';

const ApproveLoanModal = ({
  closeModal, loanId, refetch, title, subTitle, type, setModalDetail, isShow,
}: IApproveLoanModal) => {
  const [showApproveLoanSuccessfulModal, setShowApproveLoanSuccessfulModal] = useState(false);
  const Toast = useToast();
  const [fulfilLoan, { loading: approveLoanLoading }] = useMutation<
  { approveCaLoan: any },
  any
>(APPROVE_LOAN);

  const handleConfirmClick = async () => {
    if (!approveLoanLoading) {
      try {
        const res = await fulfilLoan({
          variables: {
            id: loanId,
            shouldApprove: type === 'approve',
          },
        });

        if (res?.data?.approveCaLoan && res?.data?.approveCaLoan?.status === 200) {
          Toast.success(res?.data?.approveCaLoan?.message || 'Operation successful');
          refetch?.();
          setShowApproveLoanSuccessfulModal(true);
          setModalDetail({
            title: `${type === 'approve' ? 'Approved' : 'Declined'} Successfully!`,
            subTitle: `You have successfully ${type === 'approve' ? 'approved' : 'declined'} this request and it will be reflected on your dashboard.`,
          });
        } else {
          Toast.error(res?.data?.approveCaLoan?.message || 'Operation Failed');
        }
      } catch (e) {
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };

  return (
    <AdminModal
      headText={title}
      subText={approveLoanLoading ? 'Processing...' : subTitle}
      actionBtnName="confirm"
      handleModalAction={handleConfirmClick}
      topIcon={<InfoIconNew />}
      isShow={isShow}
      isSuccess={showApproveLoanSuccessfulModal}
      onClickAway={closeModal}
      onClose={closeModal}
      isLoading={approveLoanLoading}
    />
  );
};

export default ApproveLoanModal;
